module.exports = __webpack_public_path__ + "assets/img/HH_Ki Residences_RGB_lr.eb8ae1af.jpg";